<script>

	import { initializeApp } from "firebase/app";

	import {
		getAuth,
		createUserWithEmailAndPassword,
		signInWithEmailAndPassword,
	} from "firebase/auth";

	import { getDatabase, ref, set, query, get, child, remove, onValue } from "firebase/database";


	import { fade, slide } from 'svelte/transition';
	import { onMount } from "svelte";
	import UserEdit from "./components/UserEdit.svelte";
	import TierEdit from "./components/TierEdit.svelte";

	let is_logged_in = false;
	let is_showing_history = false;
	// let current_sessions = [];
	let session_times = [];
	let scenario_maps = {};
	let scenario_user = "";

	let menu_items = [
		{
			"name": "Users",
			"icon_svg": '<path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />',
			"selected": true
		},
		{
			"name": "Access Tiers",
			"icon_svg": '<path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />',
			"selected": false
		},
		
	];

	async function doUpdateUserCreationDates(){
		console.log("... doing update user creation dates");
	    const search_data = {};
		await superagent
			.post('/api/obapi')
			.send({ action: 'get_authenticated_users', search_data: search_data }) // sends a JSON post body
			.set('accept', 'json')
			.end((err, res)=>{
	// console.log(err);
	// console.log(res);
	// console.log(res.text)
				if(err !== null){
					console.log(err.toString());
					// userNotification('error', 'Error:', err.toString());
				}else{
					res = JSON.parse(res.text);
					console.log(res);
					console.log(users);

					for(let i = 0; i < res.data.length; i++){
						const date = new Date(res.data[i]['metadata']['creationTime']);
						// creation_time_mapper[res.data[i]['uid']] = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear();
						creation_time_mapper[res.data[i]['uid']] = date;
					}
					
					let cleaned_users = [];
					for(let i = 0; i < users.length; i++){
						if(users[i]["user_id"] in creation_time_mapper){
							cleaned_users.push(users[i]);
						}
					} 
					

					console.log(creation_time_mapper);

					cleaned_users.sort((a,b) => {
			try{
				const atime = creation_time_mapper[a.user_id].getTime();
				const btime = creation_time_mapper[b.user_id].getTime();
				// console.log(`testing ${atime} against ${ btime } : ${atime - btime}`);
				return btime - atime;
			}catch(err){
				return -1;
			}
		});
					users = cleaned_users;

					// users = users;
					// if(res.st){
						// doSignInAfterSignup()
					// }else{
						// userNotification('error', 'Error:', res.msg);
					// }
				}
			});


	}

	let firebase_user = undefined;
	let auth;
	let database;
	let dbUsersRef;
	let dbTierssRef;

	function loadFirebase() {
    // TODO: Add SDKs for Firebase products that you want to use

    // https://firebase.google.com/docs/web/setup#available-libraries

    // Your web app's Firebase configuration

    // For Firebase JS SDK v7.20.0 and later, measurementId is optional

    // const firebaseConfig = {
    //   apiKey: "AIzaSyBvd_N6Qm4oaUmKvM5-rD7L_ruHg93bRzE",

    //   authDomain: "reverse-rate-search-admin.firebaseapp.com",

    //   projectId: "sprout-selling-guide",

    //   // storageBucket: "sprout-selling-guide.appspot.com",

    //   // messagingSenderId: "677904842447",

    //   appId: "1:677904842447:web:a14f5eb8db6c0220bd41ba",

    //   measurementId: "G-VSGSP88QTG",
    // };

	const firebaseConfig = {
		apiKey: "AIzaSyBvd_N6Qm4oaUmKvM5-rD7L_ruHg93bRzE",
		authDomain: "reverse-rate-search-admin.firebaseapp.com",
		projectId: "reverse-rate-search-admin",
		storageBucket: "reverse-rate-search-admin.appspot.com",
		databaseURL: "https://reverse-rate-search-admin-default-rtdb.firebaseio.com",
		messagingSenderId: "290190505821",
		appId: "1:290190505821:web:eef2741e99d17c42215ab4",
		measurementId: "G-ERKDR4E6GR"
	};


    // Initialize Firebase

    const app = initializeApp(firebaseConfig);

    auth = getAuth(app);
	database = getDatabase(app);




    console.log(auth);
    // auth.CreateUserWithEmailAndPasswordAsync('mhuffman@semperhl.com', 'asdf1234').then( res => {
    // 	console.log(res);
    // });
    // analytics = getAnalytics(app);




	/////// test database

	// function writeUserData(userId, name, email, imageUrl) {
	// 	const db = getDatabase();
	// 	set(ref(db, 'users/' + userId), {
	// 		username: name,
	// 		email: email,
	// 		profile_picture : imageUrl
	// 	});
	// }
    // let tuid = "ptLCbh1ASJZeCrrJnGCxMnUQd7Z2";
	// let db_user_id = `users/${tuid}`;
	// let tuser = {
	// 		"name": "First1 Last1",
	// 		"email": "user1@semperhl.com",
	// 		"password": "user1",
	// 		"status": "Active",
	// 		"user_id": "ptLCbh1ASJZeCrrJnGCxMnUQd7Z2",
	// 		"tier": "11111",
	// 		"editing": false
	// };
	// set(ref(database, db_user_id), tuser);

	//////////


    dbTierssRef = ref(database, '/tiers');
	console.log(dbTierssRef);

	onValue(dbTierssRef, (snapshot) => {
		const ttiers = [];
		snapshot.forEach((childSnapshot) => {
			const childKey = childSnapshot.key;
			const childData = childSnapshot.val();
			ttiers.push(childData);
			// users.push(childData);
			// console.log(`key: ${childKey}`);
			// console.log(childData);
		});
		ttiers.sort((a, b) => a.name.localeCompare(b.name));
		tiers = ttiers;
		tier_map = Object.assign({}, ...tiers.map((x) => ({[x.tier_id]: x.name})));
	});


    dbUsersRef = ref(database, '/users');
	console.log(dbUsersRef);

	onValue(dbUsersRef, (snapshot) => {
		const tusers = [];
		snapshot.forEach((childSnapshot) => {
			const childKey = childSnapshot.key;
			const childData = childSnapshot.val();
			tusers.push(childData);
			// users.push(childData);
			console.log(`key: ${childKey}`);
			console.log(childData);
		});
		// tusers.sort((a, b) => a.name.localeCompare(b.name));
		users = tusers;
		doUpdateUserCreationDates();
	});

  }



	// const db = getDatabase();
	// const starCountRef = ref(db, 'posts/' + postId + '/starCount');
	// onValue(starCountRef, (snapshot) => {
	// const data = snapshot.val();
	// updateStarCount(postElement, data);
	// });


  onMount(async () => {
	NProgress.configure({ showSpinner: false });

    loadFirebase();

	// setTimeout(()=>{
	// 	doShowUserHistory("QtDVMPbJ7Gfw0TTesDXxGs0OUAe2");
	// }, 1000);

  });


	let current_selected = "Users";

	let tier_name;
	let tier_originator_id;
	let tier_business_channel_id;
	let tier_tier_id;

	let tiers = [
		// {
		// 	"name": "Level 1",
		// 	"tier_originator_id": "111111",
		// 	"tier_business_channel_id": "11111111",
		// 	"tier_id": "11-111",
		// 	"editing": false
		// },
		// {
		// 	"name": "Level 2",
		// 	"tier_originator_id": "2222222",
		// 	"tier_id": "22222",
		// 	"editing": false
		// },
	];
	let tier_map = Object.assign({}, ...tiers.map((x) => ({[x.tier_id]: x.name})));
	

	let user_name;
	let user_email;
	let user_phone;
	let user_password;
	let user_access_tier_id;
	let user_status;
	let user_user_id;
	let user_scenario_tries;

	let users = [
		// {
		// 	"name": "First1 Last1",
		// 	"email": "user1@semperhl.com",
		// 	"password": "user1",
		// 	"status": "Active",
		// 	"user_id": "1111",
		// 	"tier": "11111",
		// 	"editing": false
		// },
		// {
		// 	"name": "First2 Last2",
		// 	"email": "user2@semperhl.com",
		// 	"password": "user2",
		// 	"status": "Active",
		// 	"user_id": "2222",
		// 	"tier": "22222",
		// 	"editing": false
		// },
		// {
		// 	"name": "First3 Last3",
		// 	"email": "user3@semperhl.com",
		// 	"password": "user3",
		// 	"status": "Inactive",
		// 	"user_id": "3333",
		// 	"tier": "33333",
		// 	"editing": false
		// },
		// {
		// 	"name": "First4 Last4",
		// 	"email": "user4@semperhl.com",
		// 	"password": "user4",
		// 	"status": "Active",
		// 	"user_id": "4444",
		// 	"tier": "11111",
		// 	"editing": false
		// },
		// {
		// 	"name": "First5 Last5",
		// 	"password": "user5",
		// 	"email": "user5@semperhl.com",
		// 	"status": "Inactive",
		// 	"user_id": "5555",
		// 	"tier": "22222",
		// 	"editing": false
		// },
		// {
		// 	"name": "First6 Last6",
		// 	"password": "user6",
		// 	"email": "user6@semperhl.com",
		// 	"status": "Active",
		// 	"user_id": "6666",
		// 	"tier": "33333",
		// 	"editing": false
		// },
	];
	let creation_time_mapper = {};
	// let sorted_users = [];
	// $: {
	// 	console.log("------------ triggering user sort");
	// 	sorted_users = users;
	// 	sorted_users.sort((a,b) => {
	// 		try{
	// 			const atime = creation_time_mapper[a.user_id].getTime();
	// 			const btime = creation_time_mapper[b.user_id].getTime();
	// 			console.log(`testing ${atime} against ${ btime } : ${atime - btime}`);
	// 			return btime - atime;
	// 		}catch(err){
	// 			return -1;
	// 		}
	// 	});
	// }

	function selectMenuItem(midx){
		for(let i = 0; i < menu_items.length; i++){
			menu_items[i]["selected"] = false;
			if(i === midx){
				menu_items[i]["selected"] = true;
				current_selected = menu_items[i]["name"];
			}
		}
	}

	let login_error = false;
	let username = "";
	let password = "";
	function doLogin(){
		console.log("doing login")
		login_error = false;
		if(username === "admin@semperhl.com" && password === "asdf1234"){
			is_logged_in = true;
			username = "";
			password = "";
		}else{
			login_error = true;
		}
	}

	function doDeleteUser(user_id){
		if(confirm("Really delete this user?")){

			//delete from Authentication 

			//delete from database
			
			// create DatabaseReference
			const dbRef = ref(database, "users/" + user_id);

			remove(dbRef).then(() => console.log("Deleted"))

			// let tusers = [];
			// for(let i = 0; i < users.length; i++){
			// 	if(users[i]["user_id"] !== user_id){
			// 		tusers.push(users[i]);
			// 	}
			// }
			// users = tusers;
		}
	}

	function doShowUserHistory(user_id){
		scenario_user = user_id;
		console.log(`showing history for ${user_id}`);
		// let current_scenarios = [];
		session_times = [];
		is_showing_history = true;

		get(ref(database, `scenarios/${user_id}/`)).then((snapshot) => {
		if (snapshot.exists()) {
			session_times = snapshot.val();
				console.log(session_times);
		} else {
			// current_sessions = [];
			session_times = [];	
			console.log("No data available");
		}
		}).catch((error) => {
			// current_sessions = [];
			session_times = [];	
			console.error(error);
		});


	}

	function doShowUserHistory2(user_id){
		session_times = [];
		scenario_maps = {};

		scenario_user = user_id;

		// let current_sessions = [];
		let current_scenarios = [];
		is_showing_history = true;
		console.log(`showing history for ${user_id}`);

		// const session_login_key = `session_login/${user_id}/`;

		// const myUserId = auth.currentUser.uid;
		// const topUserPostsRef = query(ref(database, session_login_key));
		// let sessions = [];

		// get(ref(database, `session_login/${user_id}/`)).then((snapshot) => {
		// if (snapshot.exists()) {
		// 		const tsessions = snapshot.val();
		// 		current_sessions = Object.keys(tsessions).map(key=>{return tsessions[key]});
		// 		current_sessions.sort((a, b)=>{
		// 			return a.time - b.time;
		// 		});
		// 		console.log(current_sessions);
		// } else {
		// 	current_sessions = [];
		// 	current_scenarios = [];	
		// 	console.log("No data available");
		// }
		// }).catch((error) => {
		// 	current_sessions = [];
		// 	current_scenarios = [];	
		// 	console.error(error);
		// });
		// // console.log(topUserPostsRef);

		get(ref(database, `scenarios/${user_id}/`)).then((snapshot) => {
		if (snapshot.exists()) {
				current_scenarios = snapshot.val();
				console.log(current_scenarios);

				const tsess = [...current_sessions];
				session_times = current_sessions.map(t=>{return t;}).reverse();
				console.log(session_times);
				// admin_session_times = [];

				// for(let i = 0; i < current_sessions.length; i++){
				// 	if(current_sessions[i]["is_admin_search"]){
				// 		admin_session_times.push(current_sessions[i]["time"]);
				// 	}
				// }
				// console.log(admin_session_times);

				console.log(tsess);
				scenario_maps = {"untimed": []};
				for(let i = 0 ; i < tsess.length; i++){
					scenario_maps[tsess[i]["time"]] = [];
				}
				for(let j = 0; j < current_scenarios.length; j++){
					const tscenario = {"sindex": j, ...current_scenarios[j]};
					// missing time
					if(!("time" in tscenario)){
						scenario_maps["untimed"].push(tscenario);
						continue;
					}
					// less than smallest item
					if(tscenario["time"] <= tsess[0]["time"]){
						scenario_maps[tsess[0]["time"]].push(tscenario);
						continue;
					}
					// less than smallest item
					if(tscenario["time"] >= tsess[tsess.length - 1]["time"]){
						scenario_maps[tsess[tsess.length - 1]["time"]].push(tscenario);
						continue;
					}

					// now do the rest
					for (let i = 0; i < tsess.length; i++) {
						const next_slice = tsess.slice(i, i + 2);
						if(next_slice.length == 2){
							const ltime = next_slice[0]["time"];
							const ttime = next_slice[1]["time"];
							if(tscenario["time"] >= ltime && tscenario["time"] <= ttime){
								scenario_maps[ltime].push(tscenario);
								break;
							}
						}// otherwise would have got it with the last one

					}

				}


				console.log(scenario_maps);

		} else {
			current_sessions = [];
			current_scenarios = [];	
			console.log("No data available");
		}
		}).catch((error) => {
			current_sessions = [];
			current_scenarios = [];	
			console.error(error);
		});
		// console.log(topUserPostsRef);


		// map everthing here
		// function get(arr) {
		// }

		// var arr = [1, 2, 3, 4, 5, 6, 7, 8, 9];

		// get(arr);

	}

	const cancelEdit = ()=>{
		for(let i = 0; i < users.length; i++){
			users[i]["editing"] = false;
		}

		add_item_type = undefined;

		user_name = undefined;
		user_email = undefined;
		user_phone = undefined;
		user_password = undefined;
		user_access_tier_id = undefined;
		user_status = undefined;
		user_user_id = undefined;
		user_scenario_tries = 1;
	};

	const saveEdit = ()=>{
		NProgress.start();
		let tindex;
		for(let i = 0; i < users.length; i++){
			if(users[i]["editing"]){
				tindex = i;
				break;
			}
		}

		updateUser(users[tindex]['user_id']);
		// users[tindex]['name'] = user_name;
		// users[tindex]['email'] = user_email;
		// users[tindex]['password'] = user_password;
		// users[tindex]['tier'] = user_access_tier_id;
		// users[tindex]['status'] = user_status;
		// users[tindex]['user_id'] = user_user_id;

		console.log("tindex is ", tindex);

		// console.log("user_name is ", user_name);
		// console.log("user_email is ", user_email);
		// console.log("user_phone is ", user_phone);
		// console.log("user_password is ", user_password);
		// console.log("user_access_tier_id is ", user_access_tier_id);
		// console.log("user_status is ", user_status);
		// console.log("user_user_id is ", user_user_id);

		console.log(users);
		NProgress.done();
		cancelEdit();
	};

	function doEditUser(user_id){
		let tindex = undefined;
		for(let i = 0; i < users.length; i++){
			if(users[i]["user_id"] === user_id){
				tindex = i;
				break;
			}
		}

		const tuser = users[tindex];
		console.log("... user is", tuser)
		// user_name = users[tindex]['name'];
		// user_email = users[tindex]['email'];
		// user_phone = users[tindex]['phone'];
		// user_password = users[tindex]['password'];
		// user_access_tier_id = users[tindex]['tier'];
		// user_status = users[tindex]['status'];
		// user_user_id = users[tindex]['user_id'];
		// user_scenario_tries = users[tindex]['scenario_tries'];
		user_name = tuser['name'];
		user_email = tuser['email'];
		user_phone = tuser['phone'];
		user_password = tuser['password'];
		user_access_tier_id = tuser['tier'];
		user_status = tuser['status'];
		user_user_id = tuser['user_id'];
		user_scenario_tries = tuser['scenario_tries'];


		users[tindex]["editing"] = true;

		console.log(user_name);
		console.log(user_email);
		console.log(user_phone);
		console.log(user_password);
		console.log(user_access_tier_id);
		console.log(user_status);
		console.log(user_user_id);
		console.log(user_scenario_tries);

	}

	function doDeleteTier(tier_id){
		if(confirm("Really delete this access tier?")){
			// first check if any users have this tier
			let can_delete  = true;			
			for(let i = 0; i < users.length; i++){
				console.log(users[i]["tier"]);
				if(users[i]["tier"] === tier_id){
					can_delete = false;
					break;
				}
			}

			if(can_delete){
				let ttiers = [];
				for(let i = 0; i < tiers.length; i++){
					if(tiers[i]["tier_id"] !== tier_id){
						ttiers.push(tiers[i]);
					}
				}
				tiers = ttiers;

			}else{
				alert("At least one user is using this tier. Edit user access level to delete this tier.");
			}
		}
		
	}


	const cancelTierEdit = ()=>{
		for(let i = 0; i < tiers.length; i++){
			tiers[i]["editing"] = false;
		}
		add_item_type = undefined;

		tier_name = undefined;
		tier_originator_id = undefined;
		tier_business_channel_id = undefined;
		tier_tier_id = undefined;

	};

	const saveTierEdit = ()=>{
		NProgress.start();
		let tindex;
		for(let i = 0; i < tiers.length; i++){
			if(tiers[i]["editing"]){
				tindex = i;
				break;
			}
		}

		updateTier(tiers[tindex]['tier_id']);

		// tiers[tindex]['name'] = tier_name;
		// tiers[tindex]['tier_originator_id'] = tier_originator_id;
		// tiers[tindex]['tier_business_channel_id'] = tier_business_channel_id;		
		// tiers[tindex]['tier_id'] = tier_tier_id;


		// now update affected users
		// tier_map = Object.assign({}, ...tiers.map((x) => ({[x.tier_id]: x.name})));		

		console.log("tindex is ", tindex);

		// console.log("tier_name is ", tier_name);
		// console.log("tier_originator_id is ", tier_originator_id);
		// console.log("tier_business_channel_id is ", tier_business_channel_id);
		// console.log("tier_tier_id is ", tier_tier_id);

		console.log(tiers);
		NProgress.done();
		cancelTierEdit();
	};

	function doEditTier(tier_id){
		let tindex = undefined;
		for(let i = 0; i < tiers.length; i++){
			if(tiers[i]["tier_id"] === tier_id){
				tindex = i;
				break;
			}
		}

		tier_name = tiers[tindex]['name'];
		tier_originator_id = tiers[tindex]['tier_originator_id'];
		tier_business_channel_id = tiers[tindex]['tier_business_channel_id'];
		tier_tier_id = tiers[tindex]['tier_id'];

		tiers[tindex]["editing"] = true;

	}

	let add_item_type = undefined;

	function doAddNewItem(item_type){
		add_item_type = item_type;
	}

	function updateUser(updated_user_id){
		let tuser = {};
		tuser['name'] = user_name;
		tuser['email'] = user_email;
		tuser['phone'] = user_phone;
		tuser['password'] = user_password;
		tuser['tier'] = user_access_tier_id;
		tuser['status'] = user_status;
		tuser['user_id'] = updated_user_id;
		tuser['scenario_tries'] = user_scenario_tries;
		tuser['editing'] = false;

		let db_user_id = `users/${updated_user_id}`;
		set(ref(database, db_user_id), tuser);


		console.log("user_name is ", user_name);
		console.log("user_email is ", user_email);
		console.log("user_phone is ", user_phone);
		console.log("user_password is ", user_password);
		console.log("user_access_tier_id is ", user_access_tier_id);
		console.log("user_status is ", user_status);
		console.log("user_user_id is ", updated_user_id);
		console.log("scenario_tries is ", user_scenario_tries);

		console.log(users);


	}

	function createNewUser(){

		if(
			user_name.replace(/\s+/g, '').length > 0 &&
			user_email.replace(/\s+/g, '').length > 0 &&
			user_password.replace(/\s+/g, '').length > 0 
		){

			NProgress.start();




			/////// add to firebase
			// console.log(auth);
			// let temail = "mhuffman@semperhl.com";
			// let tpass = "asdf1234";
			createUserWithEmailAndPassword(auth, user_email, user_password)
			.then((userCredential) => {
			// Signed in
			user_user_id = userCredential.user.uid;
			console.log(userCredential);

			// users.push(tuser);

			updateUser(user_user_id);

			NProgress.done();
			cancelEdit();

			// stopBusy(but_text);
			// doUserLoggedIn(userCredential.user);
			// ...
			})
			.catch((error) => {
			NProgress.done();
			const errorCode = error.code;
			const errorMessage = error.message;
			//   if (errorCode === "auth/email-already-in-use") {
			// 	login_error_message = errorCode.replace("auth/", "").replace("-", " ");
			//   }
			let login_error_message = errorCode
				.replace("auth/", "")
				.replaceAll("-", " ");
	
			// stopBusy(but_text);
			console.log(errorCode);
			console.log(errorMessage);
			// ..
			alert(login_error_message);
			});

			// auth.CreateUserWithEmailAndPasswordAsync('mhuffman@semperhl.com', 'asdf1234').then( res => {
			// 	console.log(res);
			// });


		} else {
			alert("All fields must be completed to add new user.");
		}
	}

	function updateTier(updated_tier_id){
		let ttier = {};

		ttier['name'] = tier_name;
		ttier['tier_originator_id'] = tier_originator_id;
		ttier['tier_business_channel_id'] = tier_business_channel_id;
		ttier['tier_id'] = updated_tier_id;
		ttier['editing'] = false;


		// tiers.push(ttier);
		let db_tier_id = `tiers/${updated_tier_id}`;
		set(ref(database, db_tier_id), ttier);

		/// TODO:
		// now update affected users
		// tier_map = Object.assign({}, ...tiers.map((x) => ({[x.tier_id]: x.name})));		


		console.log("tier_name is ", tier_name);
		console.log("tier_originator_id is ", tier_originator_id);
		console.log("tier_business_channel_id is ", tier_business_channel_id);
		console.log("tier_tier_id is ", tier_tier_id);

		console.log(tiers);


	}

	function createNewTIer(){

		if(
			tier_name.replace(/\s+/g, '').length > 0 &&
			tier_originator_id.replace(/\s+/g, '').length > 0 &&
			tier_business_channel_id.replace(/\s+/g, '').length > 0 
		){
			NProgress.start();

			updateTier(tier_tier_id);

			NProgress.done();
			cancelTierEdit();

		} else {
			alert("All fields must be completed to add new tier.");
		}

	}

</script>

{#if !is_logged_in}
<div transition:fade class="relative flex flex-col justify-center min-h-screen overflow-hidden">
    <div
        class="w-full p-6 m-auto bg-white border-t border-red-600 rounded shadow-lg shadow-red-800/50 lg:max-w-md">
        <!-- <h1 class="text-3xl font-semibold text-center text-red-700">LOGO</h1> -->
		<div class="logo-holder w-full">
			<img class="w-1/2 mx-auto" src="/img/semper_logo_dark.png" alt="semper home loans logo">
		</div>
        <form class="mt-6">
            <div>
                <label for="email" class="block text-sm text-gray-800">Email</label>
                <input bind:value={username} type="email"
                    class="block w-full px-4 py-2 mt-2 text-red-700 bg-white border rounded-md focus:border-red-400 focus:ring-red-300 focus:outline-none focus:ring focus:ring-opacity-40">
            </div>
            <div class="mt-4">
                <div>
                    <label for="password" class="block text-sm text-gray-800">Password</label>
                    <input bind:value={password} type="password"
                        class="block w-full px-4 py-2 mt-2 text-red-700 bg-white border rounded-md focus:border-red-400 focus:ring-red-300 focus:outline-none focus:ring focus:ring-opacity-40">
                </div>
                <!-- <a href="#" class="text-xs text-gray-600 hover:underline">Forget Password?</a> -->
                <div class="mt-6">
                    <button on:click|preventDefault={()=>{doLogin();}}
                        class="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-red-700 rounded-md hover:bg-red-600 focus:outline-none focus:bg-red-600">
                        Login
                    </button>
                </div>
        </form>
		{#if login_error}
        <p class="mt-8 text-xs font-light text-center text-red-700"> Email / Password combination incorrect. Try again.</p>			
		{/if}
    </div>
</div>

{:else if is_showing_history}
<div class="flex flex-col h-screen w-screen overflow-y-auto">
	<div class="w-screen flex flex-row items-center border-b-2">
		<div>
			<button on:click={()=>{is_showing_history = false;}} class="border-1 border-semper-red bg-semper-red text-white cursor-pointer">&#x2190; Return To Dashboard</button>
		</div>
		<div class="  text-lg pl-5"><span class="font-bold">Session history for:</span> {users.filter((e)=>{return e["user_id"] == scenario_user;})[0]["name"]}</div>
		{#if session_times.length > 0}
		<div class="text-lg pl-5"><span class="font-bold">Last Login:</span> {new Date(session_times[0]["time"]).toLocaleString()}</div>
		<div class="text-lg pl-5"><span class="font-bold">Total Scenarios:</span> {session_times.filter(e=>{return !e["is_admin_search"]}).length}</div>
		{:else}
		<div class="text-lg pl-5 font-bold">This user has no session history.</div>
		{/if}
	</div>

	<!-- {#if "untimed" in scenario_maps && scenario_maps["untimed"].length > 0}
	<div class="text-lg">Scenarios without timestamps</div>
	{#each scenario_maps["untimed"] as ni, idx}
		<div class="flex flex-row w-screen">
			<div>{idx + 1}) <a target="_blank" href="https://reverse-rate-search.netlify.app/?d={btoa(`u=${scenario_user}&s=${ni["sindex"]}`)}">"{ni["title"]}-{ni["ud"]["propertystate"]}"</a> <span class="text-sm">{new Date(ni["time"]).toLocaleString()}</span></div>
		</div>
	{/each}
	{/if} -->

	{#if session_times.length > 0}
	{#each session_times as st, idx}
	{#if !st["is_admin_search"]}
	<div class="text-lg mt-10 {st["is_admin_search"] ? "bg-semper-red text-white" : "bg-gray-700 text-white"} ">Session Start:  {new Date(st['time']).toLocaleString()}</div>
	<div class="flex flex-row w-screen">
		<div class=" w-80 ">{idx + 1}) <a target="_blank" href="https://reverse-rate-search.netlify.app/?d={btoa(`u=${scenario_user}&s=${idx}`)}">{st["title"]}-{st["ud"]["propertystate"]}</a> </div><div class="text-sm inline-block ">({new Date(st["time"]).toLocaleString()})</div>
	</div>
<!-- {#if scenario_maps[st["time"]].length > 0 } -->
	<!-- {#each scenario_maps[st["time"]] as ni, idx} -->
		<!-- <div class="flex flex-row w-screen"> -->
			<!-- <div class=" w-80 ">{idx + 1}) <a target="_blank" href="https://reverse-rate-search.netlify.app/?d={btoa(`u=${scenario_user}&s=${ni["sindex"]}`)}">{ni["title"]}-{ni["ud"]["propertystate"]}</a> </div><div class="text-sm inline-block ">({new Date(ni["time"]).toLocaleString()})</div> -->
		<!-- </div> -->
	<!-- {/each} -->
	<!-- {:else} -->
		<!-- <div>No scenario scearches for this session.</div> -->
	<!-- {/if} -->
	{/if}
		
	{/each}		
	{/if}


</div>
{:else}

<div class="flex h-screen">
	<div class="px-4 py-2 bg-gray-200 bg-semper-red lg:w-1/4">
		<svg xmlns="http://www.w3.org/2000/svg" class="inline w-8 h-8 text-white lg:hidden" fill="none"
			viewBox="0 0 24 24" stroke="currentColor">
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
		</svg>
		<div class="hidden lg:block">
			<div class="my-2 mb-6">
				<h1 class="text-2xl font-bold text-white">Admin Tool <svg on:click|preventDefault={()=>{    auth.signOut().then(() => {is_logged_in = false;});}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline w-6 h-6 cursor-pointer">
					<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
				  </svg>
				  </h1>
			</div>
			<ul>
				{#each menu_items as mi, midx}
				<li class="mb-2 {mi.selected === true ? "bg-gray-800" : "hover:bg-gray-600"} rounded shadow">
					<a href="#" on:click|preventDefault={()=>{selectMenuItem(midx);}} class="inline-block w-full h-full px-3 py-2 font-bold text-white">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6 mr-2">
							{@html mi.icon_svg}
						  </svg>						  
						{mi.name}
					</a>
				</li>
					
				{/each}

			</ul>
		</div>

	</div>

	<div class="w-full px-4 py-2 bg-gray-200 lg:w-full">
		<div class="container mx-auto mt-12">
			<div class="grid gap-4 lg:grid-cols-3">
				<div class="flex items-center justify-between px-4 py-6 bg-white rounded-md shadow-md">
					<!-- <div class="p-3 bg-semper-red rounded">
						<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-white" fill="none"
							viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
						</svg>
					</div> -->
					<div class="mx-4">
						<h4 class="text-2xl font-semibold text-gray-700">{users.length}</h4>
						<div class="text-gray-500">Users</div>
					</div>
					{#if current_selected === "Users"}
					<div on:click={()=>{doAddNewItem("user")}} class="p-3 bg-semper-red rounded cursor-pointer hover:bg-red-900">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-white">
							<path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
						  </svg>						  
					</div>						
					{/if}

				</div>
				<div class="flex items-center justify-between px-4 py-6 bg-white rounded-md shadow-md">
					<!-- <div class="p-3 bg-semper-red rounded">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-white">
							<path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
						  </svg>
					</div> -->
					<div class="mx-4">
						<h4 class="text-2xl font-semibold text-gray-700">{tiers.length}</h4>
						<div class="text-gray-500">Access Tiers</div>
					</div>
					{#if current_selected === "Access Tiers"}
					<div on:click={()=>{doAddNewItem("tier")}} class="p-3 bg-semper-red rounded cursor-pointer hover:bg-red-900">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-white">
							<path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
						  </svg>						  
					</div>						
					{/if}
				</div>

				<!-- <div class="flex items-center px-4 py-6 bg-white rounded-md shadow-md">
					<div class="p-3 bg-semper-red rounded">
						<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-white" fill="none"
							viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z" />
						</svg>
					</div>
					<div class="mx-4">
						<h4 class="text-2xl font-semibold text-gray-700">1000</h4>
						<div class="text-gray-500">All Transaction</div>
					</div>
				</div> -->
			</div>
			<div class="flex flex-col mt-8">
				<div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
					<div
						class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg">

						{#if current_selected === "Users"}
						<table class="min-w-full">
							<thead>
								<tr>
									<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Name</th>
										<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Access Tier</th>
										<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Created</th>
									<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Status</th>
									<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Edit</th>
										<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										History</th>
										<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Delete</th>
								</tr>
							</thead>

							<tbody class="bg-white">

								{#if add_item_type === "user"}
								<tr>
									<td colspan="5">
										<UserEdit
										bind:user_name={user_name}
										tiers={tiers}
										cancelHandler={cancelEdit}
										saveHandler={createNewUser}
										bind:user_access_tier_id={user_access_tier_id}
										bind:user_password={user_password}
										bind:user_email={user_email}
										bind:user_phone={user_phone}
										bind:user_status={user_status}
										bind:user_user_id={user_user_id}
										bind:user_scenario_tries={user_scenario_tries}
										/>
									</td>
								</tr>

								{/if}
									
								

								{#each users as user, idx}
								<!-- {#if creation_time_mapper[user.user_id]} -->
								<tr class="hover:shadow hover:bg-gray-100">
									<td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
										<div class="flex items-center">
											<!-- <div class="flex-shrink-0 w-10 h-10">
												<img class="w-10 h-10 rounded-full"
													src="https://source.unsplash.com/user/erondu"
													alt="admin dashboard ui">
											</div> -->

											<div class="ml-0">
												<div class="text-sm font-medium leading-5 text-gray-900">
													{user.name}
												</div>
											</div>
										</div>
									</td>

									<td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
										<div class="text-sm leading-5 text-gray-500">{tier_map[user.tier]}</div>
									</td>
									<td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
										<div class="text-sm leading-5 text-gray-500">
											{#if creation_time_mapper[user.user_id]}
											{ ((creation_time_mapper[user.user_id].getMonth() > 8) ? (creation_time_mapper[user.user_id].getMonth() + 1) : ('0' + (creation_time_mapper[user.user_id].getMonth() + 1))) + '/' + ((creation_time_mapper[user.user_id].getDate() > 9) ? creation_time_mapper[user.user_id].getDate() : ('0' + creation_time_mapper[user.user_id].getDate())) + '/' + creation_time_mapper[user.user_id].getFullYear() }
											{:else}
											missing date
											{/if}
										</div>
									</td>

									<td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
										<span
											class="inline-flex px-2 text-xs font-semibold leading-5 {user.status === "Active" ? "text-green-800 bg-green-100" : "text-red-800 bg-red-100"} rounded-full">{user.status}</span>
									</td>

									<td
										class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
										<svg on:click={()=>{doEditUser(user.user_id);}} xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-blue-400 cursor-pointer"
											fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round"
												stroke-width="2"
												d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
										</svg>
									</td>
									<td
										class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
										<svg  on:click={()=>{doShowUserHistory(user.user_id);}} xmlns="http://www.w3.org/2000/svg" fill="none" class="w-6 h-6 text-purple-500 cursor-pointer" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
											<path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
										  </svg>
									</td>

									
									  

									<td
										class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
										<svg on:click={()=>{doDeleteUser(user.user_id);}} xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-red-400 cursor-pointer"
											fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round"
												stroke-width="2"
												d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
										</svg>
									</td>
								</tr>

								{#if user.editing}
								<tr>
									<td colspan="5">
										<UserEdit
										bind:user_name={user_name}
										tiers={tiers}
										cancelHandler={cancelEdit}
										saveHandler={saveEdit}
										bind:user_access_tier_id={user_access_tier_id}
										bind:user_password={user_password}
										bind:user_email={user_email}
										bind:user_phone={user_phone}
										bind:user_status={user_status}
										bind:user_user_id={user_user_id}
										bind:user_scenario_tries={user_scenario_tries}
										/>
									</td>
								</tr>

								{/if}
								<!-- {/if} -->
								{/each}


							</tbody>
						</table>

						{:else if current_selected === "Access Tiers"}
						<table class="min-w-full">
							<thead>
								<tr>
									<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Name</th>
									<!-- <th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Access Tier</th> -->
									<!-- <th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Status</th> -->
									<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Edit</th>
									<th
										class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
										Delete</th>
								</tr>
							</thead>

							<tbody class="bg-white">

								{#if  add_item_type === "tier"}
								<tr>
									<td colspan="5">
										<TierEdit
										bind:tier_name={tier_name}
										bind:tier_originator_id={tier_originator_id}
										bind:tier_business_channel_id={tier_business_channel_id}
										bind:tier_tier_id={tier_tier_id}
										cancelHandler={cancelTierEdit}
										saveHandler={createNewTIer}
										/>
									</td>
								</tr>

								{/if}
																	
								{#each tiers as tier, idx}
								<tr class="hover:shadow hover:bg-gray-100">
									<td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
										<div class="flex items-center">

											<div class="ml-0">
												<div class="text-sm font-medium leading-5 text-gray-900">
													{tier.name}
												</div>
											</div>
										</div>
									</td>



									<td
										class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
										<svg on:click={()=>{doEditTier(tier.tier_id);}} xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-blue-400 cursor-pointer"
											fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round"
												stroke-width="2"
												d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
										</svg>
									</td>
									<td
										class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
										<svg on:click={()=>{doDeleteTier(tier.tier_id);}} xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-red-400 cursor-pointer"
											fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path stroke-linecap="round" stroke-linejoin="round"
												stroke-width="2"
												d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
										</svg>
									</td>
								</tr>
								

								{#if tier.editing}
								<tr>
									<td colspan="5">
										<TierEdit
										bind:tier_name={tier_name}
										bind:tier_business_channel_id={tier_originator_id}
										bind:tier_originator_id={tier_business_channel_id}
										bind:tier_tier_id={tier_tier_id}
										cancelHandler={cancelTierEdit}
										saveHandler={saveTierEdit}
										/>
									</td>
								</tr>

								{/if}
								

								{/each}


							</tbody>
						</table>

						{/if}

					</div>
				</div>
			</div>
		</div>
	</div>
</div>	

{/if}


<!-- <main>
	<h1 class="py-8 px-4 border border-indigo-900 shadow-lg">Hello {name}!</h1>
	<p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p>
</main> -->

<style>
	/* main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */
</style>